import {
  App,
  trackEvent,
  useCurrentApp,
  useCurrentLocale,
} from '@finn/ui-utils';
import axios from 'axios';
import dayjs from 'dayjs';
import { useCallback } from 'react';

import { useModalStore } from '../../../hooks/store';
import { useDeal } from '../../../hooks/useDeal';
import { useDealId } from '../../../providers/MetadataProvider';

export const useProlongationSubmit = () => {
  const dealId = useDealId();
  const { data: deal } = useDeal(dealId);
  // TODO find a way to avoid this
  const app = useCurrentApp();
  const { locale } = useCurrentLocale();
  const { openModal, closeModal } = useModalStore();

  const handleSubmit = useCallback(
    async (data: Record<string, { term?: string; price?: string }>) => {
      try {
        if (!data?.is_confirmed) {
          throw new Error('Prolongation terms not confirmed');
        }
        trackEvent('Prolongation Submitted', {
          dealId,
          term: data?.term?.term,
          price: data?.term?.price,
        });
        const kmPackage = deal?.mileage_package;

        const response = await axios.post(
          `/portal/api/bff/deals/${dealId}/prolongation`,
          {
            term: Number(data?.term?.term),
            amount: data.term.price,
            mileage_package: kmPackage,
            dealId,
          },
          {
            validateStatus: (status) => status === 200,
          }
        );

        if (!response.data.data.dealId) {
          throw new Error('Deal ID not found in response');
        }

        // TODO allow apps to override this behavior
        // switching to UA site so router.push will first generate an error as it's external link
        // using location.href to avoid this
        if (app === App.B2B) {
          const endDate = dayjs(deal?.minimum_commitment_end_date)
            .add(Number(data?.term?.term), 'month')
            .toISOString();
          const price = data?.term?.price;
          const term = data?.term?.term;
          window.location.href = `/car/${dealId}/prolongation/success?endDate=${endDate}&price=${price}&kmPackage=${kmPackage}&term=${term}`;
        } else {
          window.location.href = `/${locale}/checkout/thank_you/${response.data.data.contactId}/${response.data.data.dealId}`;
        }
      } catch {
        closeModal();
        openModal('prolongation-failed-modal');
        trackEvent('Prolongation Submit Failed', {
          dealId,
          term: data?.term?.term,
          price: data?.term?.price,
        });
      }
    },
    [
      dealId,
      closeModal,
      openModal,
      locale,
      app,
      deal?.mileage_package,
      deal?.minimum_commitment_end_date,
    ]
  );

  return { handleSubmit };
};
